/* HOB chrome: announcement, sticky header, menu + bag drawers, bag rendering, language, accessibility */
(function () {
  var root = document.getElementById('hob-chrome');
  if (!root || window.HOBCart) return;
  document.body.classList.add('hob-chrome-on');
  var he = root.dataset.he === 'true';
  /* cart calls go through the visitor's language (e.g. /he/cart.js) so names and links match the page language */
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fmt = root.dataset.moneyFormat || '{{amount}}';
  var FREE = Number(root.dataset.free) || 39900, FEE = Number(root.dataset.fee) || 3500;
  var T = {}; try { T = JSON.parse(document.getElementById('hobT').textContent); } catch (e) {}
  var ADDONS = []; try { ADDONS = JSON.parse(document.getElementById('hobAddons').textContent); } catch (e) {}
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var v = (cents || 0) / 100, two = v.toFixed(2), none = Math.round(v).toString();
    var wc = function (s) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals') return wc(none);
      if (k === 'amount_with_comma_separator') return two.replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return none;
      return wc(two);
    });
    var d = document.createElement('div'); d.innerHTML = out; return d.textContent.replace('NIS', '₪');
  }

  /* announcement rotation (pauses with "stop animations") */
  var ann = document.getElementById('hobAnn');
  if (ann) {
    var msgs = (ann.dataset.msgs || '').split('|'), ai = 0;
    setInterval(function () {
      if (document.documentElement.classList.contains('hob-still') || msgs.length < 2) return;
      ai = (ai + 1) % msgs.length; ann.style.opacity = 0;
      setTimeout(function () { ann.textContent = msgs[ai]; ann.style.opacity = 1; }, 300);
    }, 4500);
  }
  /* sticky header: the announcement scrolls away, the header stays */
  var sec = root.closest('.shopify-section') || root;
  function stickTop() { var a = root.querySelector('.hob-ann'); sec.style.top = a ? (-a.offsetHeight) + 'px' : '0'; }
  stickTop(); window.addEventListener('resize', stickTop);

  /* drawers */
  var scrim = document.getElementById('hobScrim'), open = null, lastFocus = null;
  function openSheet(id) {
    var s = document.getElementById(id); if (!s) return;
    if (open) closeSheet(true);
    lastFocus = document.activeElement; open = s;
    s.hidden = false; scrim.hidden = false;
    setTimeout(function () { s.classList.add('on'); }, 20);
    document.documentElement.style.overflow = 'hidden';
    root.querySelectorAll('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { var f = s.querySelector('a,button,input'); if (f) f.focus(); }, 60);
  }
  function closeSheet(keep) {
    if (!open) return; var s = open; open = null;
    s.classList.remove('on'); scrim.hidden = true; document.documentElement.style.overflow = '';
    root.querySelectorAll('[aria-controls="' + s.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!s.classList.contains('on')) s.hidden = true; }, 300);
    if (!keep && lastFocus) lastFocus.focus();
  }
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-hob-open]');
    if (o) { e.preventDefault(); var id = o.dataset.hobOpen === 'bag' ? 'hobBag' : 'hobMenu'; if (id === 'hobBag') refresh(); openSheet(id); return; }
    if (e.target.closest('[data-hob-close]')) { closeSheet(); return; }
    if (open && open.id === 'hobMenu' && e.target.closest('.hob-menu-list a,.hob-sheet-f a')) closeSheet(true);
  });
  scrim.addEventListener('click', function () { closeSheet(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); var p = document.getElementById('hobAxPanel'); if (p && !p.hidden) toggleAx(false); }
    if (e.key === 'Tab' && open) {
      var f = open.querySelectorAll('a[href],button:not([disabled]),input,select,[tabindex="0"]');
      if (!f.length) return; var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* toast */
  var toastEl = document.getElementById('hobToast'), tt;
  function toast(m) { toastEl.textContent = m; toastEl.classList.add('on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('on'); }, 2200); }

  /* bag */
  var body = document.getElementById('hobBagBody'), foot = document.getElementById('hobBagFoot'), sum = document.getElementById('hobBagSum');
  var countEl = document.getElementById('hobCount'), nEl = document.getElementById('hobBagN');
  var state = null;
  function shipFor(after) { return after >= FREE ? 0 : FEE; }
  function render(c) {
    state = c;
    var n = c.item_count;
    countEl.textContent = n; countEl.hidden = !n; nEl.textContent = n ? '(' + n + ')' : '';
    if (!n) {
      body.innerHTML = '<div class="hob-empty"><span>' + esc(T.empty) + '</span><a class="hob-btn" href="' + esc(T.shopUrl) + '">' + esc(T.shopDrop) + '</a></div>';
      foot.hidden = true; return;
    }
    var sub = c.original_total_price, after = c.total_price, disc = Math.max(0, sub - after);
    var ship = shipFor(after), total = after + ship;
    var inCart = {}; c.items.forEach(function (i) { inCart[i.handle] = 1; });
    var adds = ADDONS.filter(function (p) { return !inCart[p.handle]; }).slice(0, 6);
    var msg = '';
    if (n === 1) msg = T.m1;
    else if (n === 2 && adds.length) {
      var p = adds[0].price, simAfter = Math.round((sub + p) * 0.7), simTotal = simAfter + shipFor(simAfter);
      msg = T.m2.replace('{x}', money(Math.max(0, simTotal - total)));
    } else if (n >= 3) msg = T.m3;
    var h = '<div class="hob-box">' + (msg ? '<div class="hob-msg">' + msg + '</div>' : '') +
      '<div class="hob-bar"><i style="width:' + Math.min(100, n / 3 * 100) + '%"></i></div>' +
      '<div class="hob-steps"><span class="' + (n >= 1 ? 'on' : '') + '">1 · 15%</span><span class="' + (n >= 2 ? 'on' : '') + '">2 · 15%</span><span class="' + (n >= 3 ? 'on' : '') + '">3+ · 30%</span></div>' +
      '<div class="hob-msg" style="margin-top:8px">' + esc(after >= FREE ? T.shipOk : T.shipLeft.replace('{x}', money(FREE - after))) + '</div>' +
      '<div class="hob-bar"><i style="width:' + Math.min(100, after / FREE * 100) + '%"></i></div></div>';
    h += '<div>' + c.items.map(function (i) {
      var size = i.variant_title && i.variant_title !== 'Default Title' ? '<div class="m">' + esc(T.size) + ': ' + esc(i.variant_title) + '</div>' : '';
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
      var price = i.final_line_price < i.original_line_price ? '<s>' + money(i.original_line_price) + '</s>' + money(i.final_line_price) : money(i.final_line_price);
      return '<div class="hob-line"><a href="' + esc(i.url) + '">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="">' : '') + '</a>' +
        '<div style="min-width:0"><a class="t" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + size +
        '<div class="hob-qty"><button type="button" data-q="' + esc(i.key) + '|' + (i.quantity - 1) + '" aria-label="' + esc(T.dec) + '">−</button><span>' + i.quantity + '</span><button type="button" data-q="' + esc(i.key) + '|' + (i.quantity + 1) + '" aria-label="' + esc(T.inc) + '">+</button></div>' +
        '<div><button type="button" class="hob-rm" data-q="' + esc(i.key) + '|0">' + esc(T.remove) + '</button></div></div>' +
        '<div class="p">' + price + '</div></div>';
    }).join('') + '</div>';
    if (adds.length) {
      h += '<div style="display:flex;flex-direction:column;gap:10px;margin-top:18px"><span class="hob-lbl">' + esc(T.finish) + '</span><div class="hob-addons">' + adds.map(function (p) {
        var btns = (p.variants.length === 1 && p.variants[0].t === 'Default Title')
          ? '<button type="button" class="hob-sz" data-hob-add="' + p.variants[0].id + '" data-size="">' + esc(T.oneSize) + '</button>'
          : p.variants.map(function (v) { return '<button type="button" class="hob-sz" data-hob-add="' + v.id + '" data-size="' + esc(v.t) + '"' + (v.a ? '' : ' disabled') + '>' + esc(v.t) + '</button>'; }).join('');
        return '<div class="hob-addon"><a href="' + esc(p.url) + '"><img src="' + esc(p.img) + '" alt=""></a><a class="t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="hob-tiny">' + money(p.price) + '</span><div class="hob-sz-row">' + btns + '</div></div>';
      }).join('') + '</div></div>';
    }
    body.innerHTML = h;
    sum.innerHTML = '<div class="hob-sum"><div class="ln"><span>' + esc(T.sub) + '</span><span>' + money(sub) + '</span></div>' +
      (disc ? '<div class="ln d"><span>' + esc(T.disc) + ' (' + Math.round(disc / sub * 100) + '%)</span><span>−' + money(disc) + '</span></div>' : '') +
      '<div class="ln"><span>' + esc(T.shipping) + '</span><span>' + (ship ? money(ship) : esc(T.free)) + '</span></div>' +
      '<div class="ln tot"><span>' + esc(T.total) + '</span><span>' + money(total) + '</span></div></div>';
    document.getElementById('hobCheckout').textContent = T.checkout + ' · ' + money(total);
    foot.hidden = false;
  }
  function refresh() { return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(render).catch(function () {}); }
  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-q]'); if (!b) return;
    var p = b.dataset.q.split('|'); b.disabled = true;
    fetch(R + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: p[0], quantity: Math.max(0, Number(p[1])) }) })
      .then(function (r) { return r.json(); }).then(function (c) { if (c.items) render(c); else { toast(c.description || T.err); refresh(); } });
  });

  window.HOBCart = {
    refresh: refresh, toast: toast,
    add: function (items, btn, size) {
      if (btn) btn.classList.add('is-loading');
      return fetch(R + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json(); }).then(function (res) {
          if (btn) btn.classList.remove('is-loading');
          if (res.status) { toast(res.description || res.message || T.err); return res; }
          toast(size ? T.addedSz.replace('{s}', size) : T.added);
          return refresh().then(function () { if (!open || open.id !== 'hobBag') openSheet('hobBag'); return res; });
        }).catch(function () { if (btn) btn.classList.remove('is-loading'); toast(T.err); });
    }
  };

  /* language: remember a manual choice so automatic routing never overrides it */
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hob-lang]'); if (!a) return;
    document.cookie = 'hob_lang=manual;path=/;max-age=31536000;SameSite=Lax';
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hob-lang-foot]'); if (!a) return;
    document.cookie = 'hob_lang=manual;path=/;max-age=31536000;SameSite=Lax';
  });

  /* accessibility */
  var axBtn = document.getElementById('hobAxBtn'), axPanel = document.getElementById('hobAxPanel'), axSt = document.getElementById('hobAxSt');
  var ax = { z: 0 }; try { ax = JSON.parse(localStorage.getItem('hob-ax')) || { z: 0 }; } catch (e) {}
  function applyAx() {
    var c = document.documentElement.classList;
    c.toggle('hob-z1', ax.z === 1); c.toggle('hob-z2', ax.z === 2);
    ['contrast', 'links', 'still', 'font'].forEach(function (k) { c.toggle('hob-' + k, !!ax[k]); });
    axPanel.querySelectorAll('[data-ax-z]').forEach(function (b) { b.setAttribute('aria-pressed', String(Number(b.dataset.axZ) === (ax.z || 0))); });
    axPanel.querySelectorAll('[data-ax]').forEach(function (b) { var on = !!ax[b.dataset.ax]; b.setAttribute('aria-pressed', String(on)); b.lastElementChild.textContent = on ? '✓' : ''; });
    try { localStorage.setItem('hob-ax', JSON.stringify(ax)); } catch (e) {}
  }
  function toggleAx(on) { axPanel.hidden = !on; axBtn.setAttribute('aria-expanded', String(on)); if (on) { var f = axPanel.querySelector('button'); if (f) f.focus(); } else axBtn.focus(); }
  axBtn.addEventListener('click', function () { toggleAx(axPanel.hidden); });
  axPanel.addEventListener('click', function (e) {
    var z = e.target.closest('[data-ax-z]'); if (z) { ax.z = Number(z.dataset.axZ); applyAx(); return; }
    var k = e.target.closest('[data-ax]'); if (k) { ax[k.dataset.ax] = !ax[k.dataset.ax]; applyAx(); return; }
    if (e.target.closest('[data-ax-reset]')) { ax = { z: 0 }; applyAx(); return; }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hob-axst]') && axSt && axSt.showModal) { axSt.showModal(); }
    if (e.target.closest('[data-hob-axst-close]') && axSt) axSt.close();
  });
  if (axSt) axSt.addEventListener('click', function (e) { if (e.target === axSt) axSt.close(); });
  applyAx();

  /* keep the a11y button above the sticky add-to-bag bar on product pages */
  var sticky = document.getElementById('hobSticky');
  if (sticky && 'MutationObserver' in window) new MutationObserver(function () { document.body.classList.toggle('hob-has-sticky', sticky.classList.contains('on')); }).observe(sticky, { attributes: true, attributeFilter: ['class'] });

  refresh();
})();
